import { useEffect } from "react";

export const SITE_NAME = "MITOVKA BeautySpot";
export const SITE_URL = "https://mitovka.com";
export const DEFAULT_TITLE = `${SITE_NAME} | Online edukacije - Lash Lift i Brow Lift`;
export const DEFAULT_DESCRIPTION =
  "MITOVKA BeautySpot je sajt sa online edukacijama Lash Lift i Brow Lift. Profesionalni kursevi sa sertifikatom.";
export const DEFAULT_IMAGE = `${SITE_URL}/logo512.png`;

const upsertMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

const upsertCanonical = (href) => {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
};

/**
 * Ažurira title, description, canonical i Open Graph / Twitter tagove
 * postojećih meta elemenata iz index.html (ili ih kreira ako ne postoje).
 * Opcioni jsonLd prop renderuje schema.org strukturu za Google rich results.
 */
const SEO = ({
  title,
  description = DEFAULT_DESCRIPTION,
  path = "/",
  image = DEFAULT_IMAGE,
  type = "website",
  noindex = false,
  jsonLd = null,
}) => {
  useEffect(() => {
    const fullTitle = title ? `${title} | ${SITE_NAME}` : DEFAULT_TITLE;
    const url = `${SITE_URL}${path}`;

    document.title = fullTitle;

    upsertMeta("name", "description", description);
    upsertMeta(
      "name",
      "robots",
      noindex ? "noindex, nofollow" : "index, follow"
    );
    upsertCanonical(url);

    upsertMeta("property", "og:title", fullTitle);
    upsertMeta("property", "og:description", description);
    upsertMeta("property", "og:url", url);
    upsertMeta("property", "og:image", image);
    upsertMeta("property", "og:type", type);

    upsertMeta("name", "twitter:title", fullTitle);
    upsertMeta("name", "twitter:description", description);
    upsertMeta("name", "twitter:image", image);
  }, [title, description, path, image, type, noindex]);

  if (!jsonLd) return null;

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
    />
  );
};

export default SEO;
